export enum AttachmentType {
  Image = 1,
  PDF = 2,
  Doc = 3
}
